<div [innerHtml]="data.text"></div>

<div matDialogActions align="end">
  <button mat-button matDialogClose>{{ data.closeButtonText }}</button>
  <button mat-raised-button color="accent" (click)="onClickActionButton(data.actionButtonUrl)" cdkFocusInitial>
    {{ data.actionButtonText }}
  </button>
</div>
